import AuthService from "@/services/auth.service";
import router from "@/router";

const state = {
    user: localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")),
    oulist:[]
};

const getters = {
    isAuthenticated: (state) => !!state.user
};

const mutations = {
    auth_success(state, user) {
        state.user = user
       // router.push("/");
    },
    auth_clear(state) {
        state.user = null
    },
    onoulist_fetched(state, list){
        state.oulist = list
    }

};

const actions = {
    async EnumarateADOUList({commit}) {
        var ouList = await AuthService.api_enumADOUList();
        commit("onoulist_fetched", ouList);
    },
    async login({commit}, {email, password}) {
        var user = await AuthService.login(email, password);
        commit("auth_success", user);
        router.push( "/");
        // router.history.current.query.redirect ||
    },

    async refreshToken({commit}) {
        var user = await AuthService.refreshToken();

        commit("auth_success", user);
    },
    logout({commit}) {
        AuthService.logout();
        commit("auth_clear");
        router.push("/login")
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
